import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { router } from './app/router';
import { ErrorBoundary } from './lib/ErrorBoundary';
import { consumeHandoff } from './lib/handoff';
import { initI18n } from './lib/i18n';
import { setupPwa } from './lib/pwa';
import { queryClient } from './lib/query';
import { installGlobalErrorReporting } from './lib/telemetry';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/base.css';

installGlobalErrorReporting();
initI18n();
setupPwa();

// the api refuses user routes until a temporary password is changed (403 PASSWORD_CHANGE_REQUIRED)
window.addEventListener('pingo:password-change-required', () => {
  if (location.pathname === '/me/password') return;
  const redirect = encodeURIComponent(location.pathname + location.search);
  void router.navigate({ href: `/me/password?redirect=${redirect}` });
});

// a sign-in handed over by the mobile app is redeemed before the first route guard runs
void consumeHandoff().finally(() =>
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ErrorBoundary>
        <Suspense fallback={null}>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
          </QueryClientProvider>
        </Suspense>
      </ErrorBoundary>
    </StrictMode>,
  ),
);
